import request from "@api/request";
import { endpoints } from "@constants/endpoints";

import type { AxiosResponse } from "axios";
import type { UserDto } from "@interfaces/user";
import type { UserTokenResponseDto, GetUserTokenDto } from "@interfaces/auth";

export const isLoggedInRequest = async (): Promise<AxiosResponse<UserDto>> =>
  await request({
    url: endpoints.ME,
    method: "GET",
  });

export const getUserToken = async (
  payload: GetUserTokenDto,
): Promise<AxiosResponse<UserTokenResponseDto>> =>
  await request({
    url: endpoints.TOKEN,
    method: "POST",
    data: payload,
  });
